// src/utils/stripePayments.js

import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  getStripePayments,
  createCheckoutSession,
  getCurrentUserSubscriptions,
} from "@invertase/firestore-stripe-payments";

const app = getApp();

/*
  The Stripe Firebase extension is deployed in europe-west6.
  This must be separate from the custom EcoTrack functions
  deployed in europe-west1.
*/
const stripeFunctions = getFunctions(app, "europe-west6");

export const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "customers",
});


/**
 * Sends the customer to Stripe Checkout to start
 * the EcoTrack yearly subscription.
 */
export async function startEcoTrackSubscriptionCheckout() {
  const functions = getFunctions(app, "europe-west1");

  const createSession = httpsCallable(
    functions,
    "createEcoTrackCheckoutSession"
  );

  const result = await createSession();

  const checkoutUrl = result?.data?.url;

  if (!checkoutUrl) {
    throw new Error("Stripe checkout URL was not returned.");
  }

  window.location.assign(checkoutUrl);
}
/**
 * Returns the customer's subscriptions synced from Stripe.
 */
export async function getEcoTrackSubscriptions() {
  return await getCurrentUserSubscriptions(payments);
}

/**
 * Checks whether the customer currently has access.
 *
 * A subscription scheduled to cancel at the end of the paid period
 * remains active until that date.
 */
export async function hasActiveEcoTrackSubscription() {
  const subscriptions = await getEcoTrackSubscriptions();

  console.log("EcoTrack subscriptions found:", subscriptions);

  return subscriptions.some((sub) =>
    ["active", "trialing"].includes(sub.status)
  );
}

/**
 * Redirects the authenticated customer to Stripe Customer Portal.
 * The customer manages or cancels the subscription directly in Stripe.
 */
export async function openEcoTrackCustomerPortal(
  returnUrl = `${window.location.origin}/profile`
) {
  const functions = getFunctions(app, "europe-west1");

  const createPortalSession = httpsCallable(
    functions,
    "createEcoTrackPortalSession"
  );

  const result = await createPortalSession({
    returnUrl,
  });

  const portalUrl = result?.data?.url;

  if (!portalUrl) {
    throw new Error("Stripe customer portal URL was not returned.");
  }

  window.location.assign(portalUrl);

  } 
 
